<template>
    <div>
        <div class="d-flex align-center py-2 px-2">
            <div class="body-2 flex-grow-1">

                <v-form ref="addBarcodeForm" :disabled="addingBarcode" @submit="$event.preventDefault()">
                    <v-text-field
                            outlined
                            dense
                            label="Add Barcode"
                            hide-details="auto"
                            v-model="addBarcodeStr"
                            :rules="[validationRules.required, not6Characters, barcodeAlreadyExists]"
                            prepend-inner-icon="mdi-barcode"
                    />
                </v-form>

            </div>
            <div class="pl-2">
                <v-tooltip left>
                    <template v-slot:activator="{on}">
                        <v-btn
                                icon
                                small
                                color="error"
                                @click="addBarcode()"
                                :disabled="addingBarcode || validationRules.required(addBarcodeStr) !== true || not6Characters(addBarcodeStr) !== true || barcodeAlreadyExists(addBarcodeStr) !== true"
                                :loading="addingBarcode"
                                v-on="on"
                                :block="true"
                        >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </template>
                    Add Barcode
                </v-tooltip>
            </div>
        </div>
        <v-divider></v-divider>
        <div v-for="bCode in itemBarcodes" class="hover-item" style="cursor: pointer">
            <div class="d-flex align-center">
                <div class="body-2 pa-2 flex-grow-1">
                    {{ bCode.bCode }}
                </div>
                <div>
                    <v-tooltip left>
                        <template v-slot:activator="{on}">
                            <v-btn
                                    icon
                                    small
                                    color="error"
                                    class="mx-2"
                                    @click="removeBarcode(bCode.bCode)"
                                    :disabled="removingBarcodes.includes[bCode.bCode]"
                                    :loading="removingBarcodes.includes[bCode.bCode]"
                                    v-on="on"
                            >
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                        Remove Barcode
                    </v-tooltip>
                </div>
            </div>
            <v-divider></v-divider>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {waitForEvent} from "../../../core/socket";
import {validationRules} from "../../../core/codeFunctions";

export default {
    components: {},
    props: {
        refKey: String,
        refVal: Number,
    },
    data() {
        return {
            removingBarcodes: [],
            addBarcodeStr: null,
            addingBarcode: false,
            validationRules: validationRules
        }
    },
    watch: {

        refVal() {
            this.addBarcodeStr = null;
            try {
                this.$refs.addBarcodeForm.resetValidation();
                this.$refs.addBarcodeForm.reset();
            } catch (e) {
                console.log(e)
            }
        }

    },
    methods: {

        not6Characters: value => value !== null && value.split('').length !== 6 || '6 Character Barcodes are Reserved For Bins Only',

        barcodeAlreadyExists(barcode) {
            if (barcode && typeof this.barcodesLookup[barcode] != 'undefined')
                return 'That Barcode Has Already Been Taken'
            return true
        },


        async addBarcode() {
            if (this.$refs.addBarcodeForm.validate()) {
                this.addingBarcode = true;
                try {
                    const reqConfig = {
                        bCode: this.addBarcodeStr,
                        key: this.refKey,
                        value: this.refVal
                    }
                    const eventID = await this.$newReq('POST', `setup/barcode`, reqConfig)
                    const addedBarcode = (await waitForEvent(eventID)).barcodes.pop()
                    console.log('Barcode Added', addedBarcode)
                    this.$refs.addBarcodeForm.resetValidation();
                    this.$refs.addBarcodeForm.reset();
                    this.$snack.info('Barcode Added')
                } catch (e) {
                    console.log(e)
                    this.$snack.netWorkError()
                } finally {
                    this.addingBarcode = false;
                }
            } else {
                this.$snack.error('Invalid Barcode')
            }

        },

        async removeBarcode(bCode) {
            this.removingBarcodes.push(bCode)
            try {
                const eventID = await this.$newReq('DELETE', `setup/barcode`, {bCode})
                await waitForEvent(eventID)
                this.$snack.info('Barcode Removed')
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                this.removingBarcodes = this.removingBarcodes.filter(obj => obj !== bCode)
            }
        }

    },
    computed: {
        ...mapGetters(['barcodes', 'barcodesLookup']),
        itemBarcodes() {
            return this.barcodes.filter(barcode => barcode[this.refKey] === this.refVal)
        }
    },
}
</script>

<style scoped>

</style>